import React, { useContext } from "react";

import SectionWrapper from "../ui/SectionWrapper";
import { OutletContext } from "../../layouts/DefaultLayout";

const Section: React.FC<{
  title: string;
  children: React.ReactNode;
}> = ({ title, children }) => (
  <div className="space-y-4">
    <h3 className="text-lg font-semibold text-[#0B2545]">
      {title}
    </h3>
    <div className="space-y-3 text-[15px] leading-relaxed text-[#4B5C73]">
      {children}
    </div>
  </div>
);

const WebAndMobileDevelopment: React.FC = () => {
 const { setConsultOpen } = useContext(OutletContext);
    return(
  <SectionWrapper>
    {/* ================= HERO ================= */}
    <div className="relative rounded-b-lg bg-[#F2F4F7] overflow-hidden">

      {/* MOBILE → COLUMN | DESKTOP → ROW */}
      <div className="flex flex-col lg:flex-row">


        <div className="flex justify-center lg:justify-end order-1 lg:order-2">
        <div className="relative w-full h-[220px] sm:h-[280px] lg:w-[300px] lg:h-[500px] overflow-hidden flex items-center justify-center">
           <img
            src="/assets/optimized/web-development-1200.jpg"
            alt="Web Development"
            loading="eager"
            decoding="async"
            className="
                w-full h-full object-cover object-[50%_10%]
                lg:w-auto lg:h-full lg:max-w-none
            "
            />
            </div>
        </div>




        {/* LEFT CONTENT */}
        <div className="flex-1 px-8 py-6 order-2 lg:order-1">

          <p className=" max-w-xl text-[15px] leading-relaxed text-[#4B5C73]">
            Consumers and businesses now access services across an
            ever-increasing range of devices. Designing for a single platform
            limits reach and negatively impacts user experience.
          </p>

            <div className="my-4">
                <button
                className="inline-flex rounded-md bg-[#0B2545] px-6 py-3 text-sm font-medium text-white hover:bg-[#091D35] transition"
                onClick={() => setConsultOpen(true)}
                >
                Speak to our Web Development Team
                </button>
            </div>

          <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-[#4B5C73]">
            Our applications are built using a responsive, device-agnostic
            approach to ensure consistent performance across desktop, tablet,
            and mobile environments.
          </p>

          <div className="mt-6">
            <Section title="Website creation and design for success">
              <p>Attract. Engage. Convert. Retain customers.</p>
              <p>
                A website is no longer just an online identity — it is a primary
                marketing, engagement, and decision-making platform.
              </p>
              <p>
                We specialise in{" "}
                <strong className="text-[#0B2545]">
                  responsive web design
                </strong>{" "}
                that supports conversion, accessibility, and performance.
              </p>
            </Section>
          </div>

          <div className="mt-6">
            <Section title="Web application development">
              <p>
                Web applications transform static websites into interactive
                customer platforms — from live chat and dashboards to secure
                online transactions and integrations.
              </p>
              <p>
                Built using{" "}
                <strong className="text-[#0B2545]">
                  C#, ASP.NET, PHP, MS SQL, MySQL
                </strong>{" "}
                with security, scalability, and maintainability in mind.
              </p>
            </Section>
          </div>

          <div className="mt-6">
            <Section title="Mobile application development">
              <p>
                Native and hybrid development for{" "}
                <strong className="text-[#0B2545]">
                  iOS, Android, and Windows
                </strong>
                , supporting modern mobile-first user expectations.
              </p>
            </Section>
          </div>

          <div className="mt-6">
            <Section title="Increase traffic and conversion">
              <p>
                We support SEO and SEM strategies to ensure your digital
                platforms are discoverable, measurable, and optimised for
                action.
              </p>
            </Section>
          </div>
        </div>
      </div>
    </div>

    {/* ================= LOWER SECTION ================= */}
    <div className="rounded-lg bg-[#F2F4F7] px-8 py-10 space-y-12">
      <Section title="Keeping up with technology trends">
        <p>
          Ongoing support, maintenance, bug fixes, enhancements, and platform
          upgrades ensure your systems remain secure and competitive.
        </p>
      </Section>
    </div>
  </SectionWrapper>
);

}

export default WebAndMobileDevelopment;
